import { render, staticRenderFns } from "./icon-arrow-right.vue?vue&type=template&id=7969c03a&"
import script from "./icon-arrow-right.vue?vue&type=script&lang=js&"
export * from "./icon-arrow-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports